import {
  APP_SETTING_TOGGLE_ENCRYPTION_BEGIN,
  APP_SETTING_TOGGLE_ENCRYPTION_SUCCESS,
  APP_SETTING_TOGGLE_ENCRYPTION_FAILURE,
  APP_SETTING_TOGGLE_ENCRYPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function toggleEncryption(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_ENCRYPTION_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-encryption`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_ENCRYPTION_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_ENCRYPTION_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_ENCRYPTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleEncryptionError() {
  return {
    type: APP_SETTING_TOGGLE_ENCRYPTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_ENCRYPTION_BEGIN:
      return {
        ...state,
        toggleEncryptionPending: true,
        toggleEncryptionError: null,
      };

    case APP_SETTING_TOGGLE_ENCRYPTION_SUCCESS:
      return {
        ...state,
        toggleEncryptionPending: false,
        toggleEncryptionError: null,
        projectDetail: {
          ...state.projectDetail,
          enableEncryption: action.data.enableEncryption,
        },
      };

    case APP_SETTING_TOGGLE_ENCRYPTION_FAILURE:
      return {
        ...state,
        toggleEncryptionPending: false,
        toggleEncryptionError: action.data.error,
      };

    case APP_SETTING_TOGGLE_ENCRYPTION_DISMISS_ERROR:
      return {
        ...state,
        toggleEncryptionError: null,
      };

    default:
      return state;
  }
}
